var defaultOptions = {
    step: 4,
    exceptions: [1, 2, 6, 14, 18]
};
/**
 * Outputs a pixel length string or number, rounded to comply with the EGDS base-4 sizing rule as used to make
 * all [sizing tokens](https://egds.expedia.biz/latest/tokens/default#foundation-sizing)
 *
 * @param valueToRound {string | number} - number or pixel string to convert
 * @param returnPxString {boolean} - whether to return a string with 'px' appended (true by default), or a number
 * @param options {EgdsSizingLengthOptions} - options to manage rounding (set to EGDS defaults)
 */
var MakeEgdsSizingLength = function (valueToRound, returnPxString, options) {
    if (returnPxString === void 0) { returnPxString = true; }
    if (options === void 0) { options = defaultOptions; }
    var UnitlessValue = typeof valueToRound === 'string' ? Number(valueToRound.replace('px', '')) : valueToRound;
    var isException = options.exceptions.includes(UnitlessValue);
    if (isException) {
        return returnPxString ? "".concat(UnitlessValue, "px") : UnitlessValue;
    }
    var roundedValue = Math.round(UnitlessValue / options.step) * options.step;
    return returnPxString ? "".concat(roundedValue, "px") : roundedValue;
};

export { MakeEgdsSizingLength };
